import { Currency } from "@backmarket/http-api/src/standards/Currency";
import {
  BCP_47_LOCALES
} from "@backmarket/http-api/src/standards/Locale";
function isPriceModel(value) {
  return typeof value !== "string" && typeof value !== "number";
}
export default function createPriceFormatter(locale, defaultCurrency) {
  return (amountOrPrice, options = {}) => {
    if (
      // We want all falsy values to return an empty string (no price to show).
      // Except for 0, which is a valid price.
      !amountOrPrice && amountOrPrice !== 0 || JSON.stringify(amountOrPrice) === "{}"
    ) {
      return "";
    }
    const safeCurrency = options.currency || defaultCurrency;
    const price = isPriceModel(amountOrPrice) ? amountOrPrice : {
      amount: amountOrPrice.toString(),
      currency: safeCurrency
    };
    const { symbol = true, ...intlNumberFormatOptions } = options;
    const optionsWithOverrides = {
      currency: price.currency,
      style: "currency",
      ...intlNumberFormatOptions
    };
    const numberFormat = new Intl.NumberFormat(locale, optionsWithOverrides);
    const priceWithCurrencySymbol = numberFormat.format(
      parseFloat(price.amount)
    );
    if (symbol) {
      if (optionsWithOverrides.currency === Currency.AUD && locale === BCP_47_LOCALES.en_AU) {
        return `A${priceWithCurrencySymbol}`;
      }
      if (optionsWithOverrides.currency === Currency.JPY && locale === BCP_47_LOCALES.ja_JP) {
        const priceFormatted = numberFormat.formatToParts(parseFloat(price.amount)).map(({ type, value }) => {
          switch (type) {
            case "currency":
              return "\xA5";
            default:
              return value;
          }
        }).reduce((string, part) => string + part);
        return priceFormatted;
      }
      return priceWithCurrencySymbol;
    }
    const removeCurrencySymbolRegex = /[^\d.,-\s]+/g;
    return priceWithCurrencySymbol.replace(removeCurrencySymbolRegex, "").trim();
  };
}
